export const TRACKING_PIXEL = {
  TYPES: {
    IMG: 'img',
    IFRAME: 'iframe',
    SCRIPT: 'script',
  },
} as const;

export const GA4_EVENTS = {
  RB_DOWNLOAD_RESUME: 'rb_download_resume',
  SAVE_JOB: 'save_job',
  DISMISS_JOB: 'dismiss_job',
  DELETE_RESUME: 'delete_resume',
  COMPANY_CLAIM: 'company_claim',
  DLP_APPLY_CLICK: 'dlp_apply_click',
  CAROUSEL_JOB_CLICK: 'carousel_job_click',
  JOB_CLICK: 'job_click',
  BEGIN_CHECKOUT: 'begin_checkout',
  LOGIN: 'login',
  LOGIN_FAILED: 'login_failed',
  SIGN_UP: 'sign_up',
  SIGN_UP_FAILED: 'sign_up_failed',
  JOB_FILTER_CLICK: 'job_filter_click',
  SALARY_FILTER_CLICK: 'salary_filter_click',
  CONTENT_FILTER_CLICK: 'content_filter_click',
  SEARCH: 'search',
  DLP_APPLY_RESUME_SUBMITTED: 'dlp_apply_resume_submitted',
  RB_CALLOUT_CLICK: 'rb_callout_click',
  JOB_CALLOUT_CLICK: 'job_callout_click',
  CAREER_QUIZ_CALLOUT_CLICK: 'career_quiz_callout_click',
  REVIEWS_CALLOUT_CLICK: 'reviews_callout_click',
  SALARY_REPORT_CALLOUT_CLICK: 'salary_report_callout_click',
  EASY_APPLY_WITH_LINKEDIN_CLICK: 'dlp_apply_linkedin_apply_click',
  CREATE_SUBSCRIPTION: 'create_subscription',
} as const;

export const STRIPE_RESUME_BUILDER_PLANS = {
  STANDARD: {
    KEY: 'STANDARD_PLAN_ID',
    TITLE: 'Standard',
    PRICE: '25',
  },
} as const;

export const STRIPE_POST_A_JOB_PLANS = {
  STARTER_DAILY: {
    KEY: 'STARTER_DAILY_PLAN_ID',
    TITLE: 'Starter',
    PRICE: '12',
  },
  STARTER_MONTHLY: {
    KEY: 'STARTER_MONTHLY_PLAN_ID',
    TITLE: 'Starter',
    PRICE: '288',
  },
  PREMIUM_DAILY: {
    KEY: 'PREMIUM_DAILY_PLAN_ID',
    TITLE: 'Premium',
    PRICE: '19',
  },
  PREMIUM_MONTHLY: {
    KEY: 'PREMIUM_MONTHLY_PLAN_ID',
    TITLE: 'Premium',
    PRICE: '456',
  },
  ON_DEMAND: {
    KEY: '',
    TITLE: 'Enterprise',
    PRICE: '',
  },
} as const;

export const STRIPE_COMPANY_PROFILE_PLANS = {
  FREE: {
    KEY: 'FREE_PLAN_ID',
    TITLE: 'FREE',
    PRICE: 'FREE',
  },
  SMALL: {
    KEY: 'SMALL_PLAN_ID',
    TITLE: 'Small',
    PRICE: '$299/mo',
    COMPANY_SIZE: [0, 500],
  },
  MEDIUM: {
    KEY: 'MEDIUM_PLAN_ID',
    TITLE: 'Medium',
    PRICE: '$599/mo',
    COMPANY_SIZE: [501, 2999],
  },
  LARGE: {
    KEY: 'LARGE_PLAN_ID',
    TITLE: 'Large',
    PRICE: '$999/mo',
    COMPANY_SIZE: [3000, -1],
  },
  FEATURED_SMALL: {
    KEY: 'FEATURED_SMALL_PLAN_ID',
    TITLE: 'Small Companies + Best Company List Feature',
    PRICE: '$498/mo',
    COMPANY_SIZE: [0, 500],
  },
  FEATURED_MEDIUM: {
    KEY: 'FEATURED_MEDIUM_PLAN_ID',
    TITLE: 'Medium Companies + Best Company List Feature',
    PRICE: '$798/mo',
    COMPANY_SIZE: [501, 2999],
  },
  FEATURED_LARGE: {
    KEY: 'FEATURED_LARGE_PLAN_ID',
    TITLE: 'Large Companies + Best Company List Feature',
    PRICE: '$1,198/mo',
    COMPANY_SIZE: [3000, -1],
  },
} as const;

export const PLAN_CATEGORIES = {
  RESUME_BUILDER: 'RESUME_BUILDER',
  EMPLOYER_JOB_POSTING: 'EMPLOYER_JOB_POSTING',
  COMPANY_PROFILE: 'COMPANY_PROFILE',
} as const;

export const SEARCH_SOURCES = {
  CLUSTER_HEADER: 'cluster-header',
  MAIN_HEADER: 'main-header',
  COMPANY_SEARCH: 'company-search',
  SITE_MAP_SEARCH_ALL: 'site-map-search-all',
  SITE_MAP_SEARCH: 'site-map-search',
  JOB_SEARCH: 'job-search',
};

export const SURVEYS = {
  SALARY_REPORT: '201',
};

export const GA4_EMPLOYER_EVENTS = {
  DOWNLOAD: 'download',
  INTERESTED: 'interested',
  NOT_INTERESTED: 'not-interested',
  EMAIL_COPY: 'email-copy',
  CANDIDATES_CLICK: 'candidates-click',
  JOB_DESCRIPTION_TEMPLATE_CLICK: 'job-description-template-click',
};

export const AUTOSUGGEST_CATEGORIES = {
  JOB_TITLE: 'jobTitle',
  LOCATION: 'location',
  LOCATION_EXTENDED: 'locationExtended',
  MAJOR: 'major',
  COMPANY: 'company',
  COLLEGE: 'college',
  SKILLS: 'skills',
  CERTIFICATION: 'certification',
  LANGUAGE: 'language',
  SUGGESTIONS: 'suggestions',
};

export const ENTITY_TYPE = {
  TITLE: 'title',
  COMPANY: 'company',
  MAJOR: 'major',
};

export const COMPANY_PROFILE_SETTINGS_STEPS = {
  DETAILS: 'company-info',
  PICTURES_AND_VIDEOS: 'pictures-and-videos',
  EXECUTIVES: 'executives',
  DESCRIPTION: 'company-description',
  CULTURE: 'culture',
  BENEFITS: 'benefits',
  MISSION_STATEMENT: 'mission-statement',
  UPDATES: 'company-updates',
  PAGE_DISPLAY_CUSTOMIZATION: 'page-display-customization',
  BEST_COMPANY_SPOTLIGHT: 'best-company-spotlight',
} as const;

export const COMPANY_PROFILE_SETTINGS_STEPS_LIST = Object.values(COMPANY_PROFILE_SETTINGS_STEPS);

export const COMPANY_PROFILE_SETTINGS_STEPS_DATA = {
  [COMPANY_PROFILE_SETTINGS_STEPS.DETAILS]: {
    name: 'Company Details',
    isFree: true,
  },
  [COMPANY_PROFILE_SETTINGS_STEPS.PICTURES_AND_VIDEOS]: {
    name: 'Pictures and Videos',
    isFree: false,
  },
  [COMPANY_PROFILE_SETTINGS_STEPS.EXECUTIVES]: {
    name: 'CEO & Executives',
    isFree: true,
  },
  [COMPANY_PROFILE_SETTINGS_STEPS.DESCRIPTION]: {
    name: 'Company Description',
    isFree: true,
  },
  [COMPANY_PROFILE_SETTINGS_STEPS.CULTURE]: {
    name: 'Culture',
    isFree: false,
  },
  [COMPANY_PROFILE_SETTINGS_STEPS.BENEFITS]: {
    name: 'Benefits',
    isFree: false,
  },
  [COMPANY_PROFILE_SETTINGS_STEPS.MISSION_STATEMENT]: {
    name: 'Mission Statement',
    isFree: false,
  },
  [COMPANY_PROFILE_SETTINGS_STEPS.UPDATES]: {
    name: 'Company Updates',
    isFree: false,
  },
  [COMPANY_PROFILE_SETTINGS_STEPS.PAGE_DISPLAY_CUSTOMIZATION]: {
    name: 'Page Display Customization',
    isFree: false,
  },
  [COMPANY_PROFILE_SETTINGS_STEPS.BEST_COMPANY_SPOTLIGHT]: {
    name: 'Best Company Spotlight',
    isFree: true,
  },
} as const;

export const HAND_WRITTEN_INTROS = {
  TYPE: {
    JOB_INTRO: 'JOB_INTRO',
    BRIEF_JOB_DESCRIPTION: 'BRIEF_JOB_DESCRIPTION',
    BRIEF_SKILL_DESCRIPTION: 'BRIEF_SKILL_DESCRIPTION',
    SKILL_INTRO: 'SKILL_INTRO',
    HOW_TO_BECOME: {
      INTRO: 'HOW_TO_BECOME_1_INTRO',
      EDUCATION: 'HOW_TO_BECOME_2_EDUCATION',
      CERTIFICATIONS: 'HOW_TO_BECOME_3_CERTIFICATIONS',
      LICENSES: 'HOW_TO_BECOME_4_LICENSES',
      PREVIOUS_EXP: 'HOW_TO_BECOME_5_PREVIOUS_EXP',
    },
    JOB_DESCRIPTION_PAGE_INTRO: 'JOB_DESCRIPTION_PAGE_INTRO',
    HOW_TO_BECOME_INTRO: 'HOW_TO_BECOME_INTRO',
    JOB_TITLE_DEFINITION: 'JOB_TITLE_DEFINITION',
    JOB_TITLE_SPECIAL: 'JOB_TITLE_SPECIAL',
    JOB_TITLE_PROS_CONS: 'JOB_TITLE_PROS_CONS',
  },
  ENTITY_TYPE: {
    JOB_TITLE: 'JOB_TITLE',
    SKILLS: 'SKILLS',
  },
};

